<!-- Drawer panel — two columns: chat + debug log -->
<div class="mcp-drawer-panel" [class.mcp-drawer-open]="isOpen">
    <!-- Header -->
    <div class="mcp-drawer-header">
        <div class="mcp-header-left">
            <mat-icon class="mcp-header-icon">auto_awesome</mat-icon>
            <div class="mcp-header-text">
                <span class="mcp-header-title">Assistant</span>
                <span class="mcp-status-label" [class]="'mcp-status-' + status">
                    {{ statusLabel }}
                </span>
            </div>
        </div>
        <div class="mcp-header-right">
            <button
                mat-icon-button
                [class.mcp-debug-active]="showDebug"
                (click)="showDebug = !showDebug"
                matTooltip="Toggle debug log"
            >
                <mat-icon>bug_report</mat-icon>
            </button>
            <button
                mat-icon-button
                [class.mcp-session-active]="status === 'active'"
                (click)="onSessionToggle()"
                [matTooltip]="sessionTooltip"
                [disabled]="status === 'connecting'"
            >
                <mat-spinner *ngIf="status === 'connecting'" diameter="24"></mat-spinner>
                <mat-icon *ngIf="status !== 'connecting'">{{ sessionIcon }}</mat-icon>
            </button>
            <button mat-icon-button (click)="close()" matTooltip="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Two-column body -->
    <div class="mcp-body" [class.mcp-body-with-debug]="showDebug">
        <!-- LEFT: Chat transcript -->
        <div class="mcp-chat-col">
            <div class="mcp-transcript" #transcriptContainer>
                <div *ngIf="transcript.length === 0" class="mcp-empty-state">
                    <mat-icon class="mcp-empty-icon">chat_bubble_outline</mat-icon>
                    <p>Connect the session, then hold the mic button to talk</p>
                </div>

                <div
                    *ngFor="let entry of transcript"
                    class="mcp-message"
                    [class.mcp-message-user]="entry.role === 'user'"
                    [class.mcp-message-assistant]="entry.role === 'assistant'"
                    [class.mcp-message-system]="entry.role === 'system'"
                >
                    <div class="mcp-message-bubble">
                        {{ entry.text }}
                    </div>
                </div>

                <div *ngIf="aiSpeaking" class="mcp-typing-indicator">
                    <span></span><span></span><span></span>
                </div>
            </div>

            <!-- Input bar -->
            <div class="mcp-input-bar">
                <button
                    mat-icon-button
                    class="mcp-ptt-btn"
                    [class.mcp-ptt-active]="!micMuted"
                    (mousedown)="onPushToTalkDown()"
                    (mouseup)="onPushToTalkUp()"
                    (mouseleave)="onPushToTalkUp()"
                    (touchstart)="onPushToTalkDown()"
                    (touchend)="onPushToTalkUp()"
                    [disabled]="status !== 'active'"
                    [matTooltip]="status === 'active' ? 'Hold to talk' : 'Connect session first'"
                >
                    <mat-icon>{{ micMuted ? 'mic_off' : 'mic' }}</mat-icon>
                </button>

                <input
                    #textInput
                    type="text"
                    class="mcp-text-input"
                    placeholder="Type a message..."
                    [(ngModel)]="textMessage"
                    (keydown)="onTextKeydown($event)"
                    [disabled]="status !== 'active'"
                />
                <button
                    mat-icon-button
                    class="mcp-send-btn"
                    (click)="onSendText()"
                    [disabled]="status !== 'active' || !textMessage.trim()"
                >
                    <mat-icon>send</mat-icon>
                </button>
            </div>
        </div>

        <!-- RIGHT: Debug log -->
        <div class="mcp-debug-col" *ngIf="showDebug">
            <div class="mcp-debug-header">
                <span>Debug Log</span>
                <button mat-icon-button (click)="clearTrace()" matTooltip="Clear log">
                    <mat-icon>delete_sweep</mat-icon>
                </button>
            </div>
            <div class="mcp-debug-scroll" #debugContainer>
                <div *ngIf="traceEvents.length === 0" class="mcp-debug-empty">
                    No events yet
                </div>
                <div
                    *ngFor="let ev of traceEvents; trackBy: trackTrace"
                    class="mcp-debug-event"
                    [class.mcp-debug-error]="ev.type === 'realtime_error' || ev.detail?.includes('failed') || ev.detail?.includes('not found')"
                    [class.mcp-debug-success]="ev.detail?.includes('success')"
                    [class.mcp-debug-tool]="ev.type === 'tool_call_received' || ev.type === 'page_action_dispatched'"
                >
                    <div class="mcp-debug-time">{{ formatTime(ev.at) }}</div>
                    <div class="mcp-debug-type">{{ ev.type }}</div>
                    <div class="mcp-debug-detail" *ngIf="ev.detail">{{ ev.detail }}</div>
                    <div class="mcp-debug-data" *ngIf="ev.data">{{ formatData(ev.data) }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
